import { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { useRouter } from 'next/router';
import { getData } from '@portal-internet/bff';
import { getDataGraph } from 'components/3catinfo/Eleccions/Grafiques/GraficEleccions/dataParserEleccions';
import __isEmpty from 'lodash/isEmpty';
import __isUndefined from 'lodash/isUndefined';

const normalizeDades = (data) => {
    if (!data) return data;
    if (data.resposta?.items) {
        return data.resposta.items;
    }
    return data;
};

export const useEleccions = () => {
    const router = useRouter();
    const [urlDades, setUrlDades] = useState(null);
    const [urlDadesComparador, setUrlDadesComparador] = useState(null);
    const [intervalRefresh, setIntervalRefresh] = useState(null);
    const [dataActualFormat, setDataActualFormat] = useState(null);
    const [dataComparadorFormat, setDataComparadorFormat] = useState(null);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const queryProps = useRef({});

    const optionsQuery = {
        initialData: null,
        staleTime: 0,
        refetchOnMount: 'always',
        refetchInterval: intervalRefresh
    };
    const enabledDades = !!urlDades;
    const enabledDadesComparador = !!urlDadesComparador;

    const { data: dataActual } = useQuery(['grafic-eleccions', { url: urlDades, fetchFromOrigin: true }], getData, {
        ...optionsQuery,
        enabled: enabledDades
    });
    const { data: dataComparador } = useQuery(
        ['grafic-eleccions-comparador', { url: urlDadesComparador, fetchFromOrigin: true }],
        getData,
        { ...optionsQuery, refetchInterval: 0, enabled: enabledDadesComparador }
    );

    useEffect(() => {
        const dataActualNormalize = normalizeDades(dataActual);
        const dataComparadorNormalize = normalizeDades(dataComparador);
        const isDataActualLoaded = __isUndefined(urlDades) || dataActualNormalize !== null;
        const isDataComparadorLoaded =
            __isUndefined(urlDadesComparador) || urlDadesComparador === null || dataComparadorNormalize !== null;
        if (isDataActualLoaded && isDataComparadorLoaded && !__isEmpty(queryProps.current.dataGraphFormatType)) {
            const dataActualFormatTmp = getDataGraph(queryProps.current.dataGraphFormatType, dataActualNormalize, {
                ...queryProps.current.params
            });
            setDataActualFormat(dataActualFormatTmp);
            setDataComparadorFormat(
                getDataGraph(queryProps.current.dataGraphFormatType, dataComparadorNormalize, {
                    isSecondary: true,
                    dataActual: dataActualFormatTmp,
                    ...queryProps.current.params
                })
            );
        } else {
            setIsDataLoaded(isDataActualLoaded && isDataComparadorLoaded);
        }
    }, [urlDades, urlDadesComparador, dataActual, dataComparador]);

    useEffect(() => {
        if (!__isEmpty(dataActualFormat) && (!__isEmpty(dataComparadorFormat) || __isEmpty(urlDadesComparador))) {
            setIsDataLoaded(true);
        }
    }, [dataActualFormat, dataComparadorFormat]);

    const getSlugEleccions = () => {
        //const parts = router.asPath.split('/').filter(Boolean);
        //return parts[1];
        const ignore = ['qa', 'eleccions'];
        const match = router.asPath.match(/3catinfo\/((?:[^\/]+\/)*)([^\/]+)/);

        if (!match) return null;

        const pathSegments = match[1].split('/').filter(Boolean);

        const slug = pathSegments.find((segment) => !ignore.includes(segment));
        return slug || match[2];
    };

    const getDades = (propsQuery) => {
        queryProps.current = { ...propsQuery };
        setUrlDades(propsQuery.urlDades);
        setUrlDadesComparador(propsQuery.urlDadesComparador);
        setIntervalRefresh(propsQuery.intervalRefresh);
    };

    return {
        getSlugEleccions,
        getDades,
        dataActual: normalizeDades(dataActual),
        dataComparador: normalizeDades(dataComparador),
        dataActualFormat,
        dataComparadorFormat,
        isDataLoaded
    };
};
